import { FormGroupRules } from '@shared/models/interfaces/form-group-rules.model';
import { ammControlloFormValidators } from '../../validators/amm-controllo-common.form-validators';
import { CkNormeValuesEnum } from '../../common/consts/ckNormeValues.enum';
import { normeSrlAssembleaRules } from './norme-srl-assemblea.rules';
import { normeSrlTipoAmmRules } from './norme-srl-tipo-amm.rules';
import { normeSrlOrganoControlloRules } from './norme-srl-organo-controllo.rules';

export const NormeSrlRules: FormGroupRules = {
    ...normeSrlAssembleaRules,
    ...normeSrlTipoAmmRules,
    ...normeSrlOrganoControlloRules,
};

export const NormeSrlFormValidators = [...Object.values(NormeSrlRules), ...ammControlloFormValidators(CkNormeValuesEnum.normeSrl)];
